import PropTypes from "prop-types";
import ApiDescription from "./ApiDescription";
import tradingApiData from "./tableData";
import React from "react";
import ScrollSpy from "react-ui-scrollspy";

function TradingApi({ scrollRef, search }) {
  return (
    <ScrollSpy
      activeClass="ss-actives"
      offsetBottom={500}
      scrollThrottle={80}
      parentScrollContainerRef={scrollRef}
    >
      <ApiDescription data={tradingApiData} search={search} />
    </ScrollSpy>
  );
}

TradingApi.propTypes = {
  scrollRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }).isRequired,
  search: PropTypes.string.isRequired,
};

export default TradingApi;
